// extracted by mini-css-extract-plugin
module.exports = {"assessmentCards":"style__assessmentCards__t4lYd"};